import { Button } from "@/components/ui/button";
import { Check, ShieldCheck, Zap, TrendingUp } from "lucide-react";

export default function PricingSection({ t, navigate }) {
  return (
    <section id="pricing" className="py-20" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{t.plans.title}</h2>
          <p className="text-base text-gray-500 mb-4">{t.plans.subtitle}</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {t.plans.trialNote && (
              <div className="inline-flex items-center gap-2 text-sm font-medium text-green-700 bg-green-50 border border-green-200 px-4 py-1.5 rounded-full">
                <ShieldCheck className="w-4 h-4" />{t.plans.trialNote}
              </div>
            )}
            {t.plans.noCommission && (
              <div className="inline-flex items-center gap-2 text-sm font-medium text-[#CDA34F] bg-[#CDA34F]/10 border border-[#CDA34F]/20 px-4 py-1.5 rounded-full">
                <Zap className="w-4 h-4" />{t.plans.noCommission}
              </div>
            )}
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto items-start">
          {t.plans.items.map((plan, i) => (
            <div key={i} className={`rounded-2xl border-2 transition-shadow ${plan.popular ? "border-[#CDA34F] shadow-2xl shadow-[#CDA34F]/15 relative -mt-4 pb-4" : "border-gray-200 hover:shadow-lg"}`} data-testid={`plan-${plan.name.toLowerCase()}`}>
              {plan.popular && (
                <div className="bg-[#CDA34F] rounded-t-xl py-2 text-center">
                  <span className="text-white text-xs font-bold uppercase tracking-wider">{t.plans.popular}</span>
                </div>
              )}
              <div className="p-8">
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{plan.name}</h3>
                  <p className="text-sm text-gray-500">{plan.desc}</p>
                  {plan.popular && t.plans.proRecommended && (
                    <p className="text-xs font-semibold text-[#CDA34F] mt-1">{t.plans.proRecommended}</p>
                  )}
                </div>
                <div className="mb-6">
                  <span className="text-5xl font-extrabold text-gray-900">{plan.price}</span>
                  <span className="text-gray-500 ml-1">{t.plans.currency}</span>
                </div>
                <Button onClick={() => navigate("/login")} className={`w-full h-12 font-bold uppercase tracking-wide rounded-lg mb-8 ${plan.popular ? "bg-[#CC0000] hover:bg-[#a30000] text-white" : "bg-gray-100 hover:bg-gray-200 text-gray-900"}`}>{plan.cta}</Button>
                <ul className="space-y-3">
                  {plan.features.map((f, j) => (
                    <li key={j} className={`flex items-start gap-3 text-sm ${j === 0 && f.includes("+") || f.includes("plus:") || f.includes("mais:") || f.includes("más:") ? "font-semibold text-gray-800" : "text-gray-600"}`}>
                      <Check className="w-5 h-5 text-[#CDA34F] flex-shrink-0 mt-0.5" />{f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        {(t.plans.anchor || t.plans.urgency) && (
          <div className="mt-10 text-center space-y-2">
            {t.plans.anchor && (
              <div className="inline-flex items-center gap-2 text-sm text-gray-500 bg-gray-50 px-4 py-2 rounded-lg">
                <TrendingUp className="w-4 h-4 text-[#CDA34F]" />{t.plans.anchor}
              </div>
            )}
            {t.plans.urgency && (
              <p className="text-xs font-semibold text-[#CC0000] uppercase tracking-wider">{t.plans.urgency}</p>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
